// @flow
import styled from 'styled-components';

export const SliderContainer = styled.div`
    position: relative;
    height: 30px;
    width: 100%;
`;

export const Slider = styled.input`
    position: absolute;
    appearance: none;
    background: none;
    vertical-align: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: none;
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background: white;
        box-shadow: ${props => `-2px 2px 2px ${props.theme.heavyGrey},
			1px -1px 1px ${props.theme.lightGrey}`};
        position: relative;
        z-index: 500;
    }

    &::-moz-range-thumb {
        z-index: 500;
        border: none;
        box-shadow: ${props => `-2px 2px 2px ${props.theme.heavyGrey},
			1px -1px 1px ${props.theme.lightGrey}`};
        background: white;
    }

    &::-ms-thumb {
        border: none;
        height: 16px;
        width: 16px;
        border-radius: 50%;
        background: ${props => props.theme.mainBrandColor};
    }

    &::-moz-range-track {
        background: none;
    }

    &:focus {
        outline: none;
    }
`;

export const SliderColorBar = styled.div`
    pointer-events: none;
    position: absolute;
    height: 3px;
    top: calc(50% - 1.5px);
    background-color: ${props => {
        if (props.disabled) {
            return props.theme.lightGrey;
        }

        return props.highlightProgress ? props.theme.mainBrandColor : props.theme.lightGrey;
    }};
    width: 100%;
`;

export const SetValueContainer = styled.p`
    display: flex;
    flex-direction: column;
    color: ${({ disabled, theme }) => (disabled ? theme.mediumGrey : theme.mainBrandColor)};
    text-align: center;
    width: 10%;
    margin-left: 15px;
`;

export const RangeSliderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const LabelText = styled.div`
    white-space: nowrap;
    font-size: 0.8em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/range-slider/styles.js